import React, { useState } from 'react';
import StepIndicator from '../components/StepIndicator';
import StepEndereco from '../components/StepEndereco';
import StepResponsavel from '../components/StepResponsavel';
import StepNegocio from '../components/StepNegocio';
import StepExplicacao from '../components/StepExplicacao';
import StepCategoria from '../components/StepCategoria';
import StepLogin from '../components/StepLogin';
import StepConfirmacao from '../components/StepConfirmacao';
import './CadastroParceiro.css';

interface Step {
  number: number;
  title: string;
}

const steps: Step[] = [
  { number: 1, title: 'Responsável' },
  { number: 2, title: 'Cadastre seu endereço' },
  { number: 3, title: 'Negócio' },
  { number: 4, title: 'Explicação' },
  { number: 5, title: 'Repasse' },
  { number: 6, title: 'Login' },
  { number: 7, title: 'Confirmação' },
];

export const CadastroParceiroPage: React.FC = () => {
  const [currentStep, setCurrentStep] = useState(1);

  const handleNext = () => {
    if (currentStep === 1) {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ event: 'cadastro_telefone' });
    }
    setCurrentStep(prev => Math.min(prev + 1, steps.length));
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const handleBack = () => {
    setCurrentStep(prev => Math.max(prev - 1, 1));
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const renderStepContent = () => {
    switch (currentStep) {
      case 1:
        return <StepResponsavel onNext={handleNext} />;
      case 2:
        return <StepEndereco onNext={handleNext} onBack={handleBack} />;
      case 3:
        return <StepNegocio onNext={handleNext} onBack={handleBack} />;
      case 4:
        return <StepExplicacao onNext={handleNext} onBack={handleBack} />;
      case 5:
        return <StepCategoria onNext={handleNext} onBack={handleBack} />;
      case 6:
        return <StepLogin onNext={handleNext} onBack={handleBack} />;
      case 7:
        return <StepConfirmacao onBack={handleBack} />;
      default:
        return null;
    }
  };

  return (
    <div className="cadastro-parceiro-page">
      <main className="cadastro-main">
        <div className="cadastro-container">
          <div className="cadastro-header">
            <h1 className="cadastro-title">Cadastro de Parceiro</h1>
            <p className="cadastro-subtitle">
              Preencha os dados para começar a receber clientes. Nós levamos os clientes para a sua loja — você só precisa atendê-los.
            </p>
          </div>

          <div className="cadastro-content">
            <div className="cadastro-sidebar">
              <StepIndicator steps={steps} currentStep={currentStep} />
              <div className="help-section">
                <p className="help-text">Precisa de ajuda?</p>
                <a href="#suporte" className="help-link">Fale com nosso suporte</a>
              </div>
            </div>

            <div className="cadastro-form-panel">
              <div className="mobile-step-bar">
                <div className="mobile-step-bar-info">
                  <span className="mobile-step-bar-count">PASSO {currentStep} DE {steps.length}</span>
                  <span className="mobile-step-bar-title">{steps[currentStep - 1].title}</span>
                </div>
                <div className="mobile-step-bar-track">
                  <div
                    className="mobile-step-bar-fill"
                    style={{ width: `${(currentStep / steps.length) * 100}%` }}
                  />
                </div>
              </div>

              {renderStepContent()}
            </div>
          </div>
        </div>
      </main>
    </div>
  );
};
